import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Document, Page, pdfjs } from 'react-pdf';
import { usePdfPreview } from 'components/ShareDocument/SharePreviewContent/PdfPreviewProvider';

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

const PdfPreviewSkeleton = () => (
  <div className='p-3'>
    <SkeletonTheme baseColor='#f2f2f2'>
      <div
        className='bg-white border-general border-grey-50 rounded mx-auto specific-y-padding-40 specific-x-padding-32'
        style={{ maxWidth: '640px' }}
      >
        <Skeleton height={28} width='55%' className='mb-4' />
        <Skeleton count={5} className='mb-2' />
        <Skeleton width='80%' className='mb-4' />
        <Skeleton count={6} className='mb-2' />
        <Skeleton width='40%' className='mb-4' />
        <Skeleton count={4} className='mb-2' />
        <Skeleton width='65%' />
      </div>
    </SkeletonTheme>
  </div>
);

/** Renders the scrollable page list; all state/behaviour lives in PdfPreviewProvider. */
const PdfPreview = () => {
  const { url, pages, zoom, containerWidth, toolbarHeight, scrollContainerRef, pageRefs, setPages } = usePdfPreview();

  return (
    <div className='rounded'>
      <div className='overflow-auto attachment-pdf-fill-preview rounded border-grey-50' ref={scrollContainerRef}>
        <Document
          file={url}
          onLoadSuccess={({ numPages }) => setPages(numPages)}
          loading={<PdfPreviewSkeleton />}
          error={<p className='paragraph-general mb-0 p-3'>Unable to preview this PDF file.</p>}
        >
          {Array.from({ length: pages }, (_, index) => {
            const pageNumber = index + 1;

            return (
              <div
                key={`page-${pageNumber}`}
                ref={(el) => {
                  pageRefs.current[pageNumber] = el;
                }}
                data-page-number={pageNumber}
                style={{ scrollMarginTop: `${toolbarHeight}px` }}
              >
                <Page
                  pageNumber={pageNumber}
                  width={containerWidth ? containerWidth * zoom : undefined}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                  className='attachment-pdf-page'
                />
              </div>
            );
          })}
        </Document>
      </div>
    </div>
  );
};

export default PdfPreview;
